import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Car } from "@phosphor-icons/react";
import { useI18n } from "@/lib/i18n";

/**
 * Escape hatch shown under login / register / register-agency forms so users
 * who do not actually want an account can immediately jump to the public
 * booking flow without feeling stuck in the auth journey.
 */
export default function BookWithoutAccountCTA({ testid = "auth-book-no-account" }) {
  const navigate = useNavigate();
  const { t } = useI18n();
  return (
    <div className="mt-4 space-y-2">
      <div className="flex items-center gap-3" aria-hidden="true">
        <div className="flex-1 h-px bg-zinc-800" />
        <span className="text-[11px] uppercase tracking-widest text-zinc-600">{t("auth.or_divider")}</span>
        <div className="flex-1 h-px bg-zinc-800" />
      </div>
      <p className="text-xs text-zinc-500 text-center">{t("auth.book_hint")}</p>
      <Button
        data-testid={testid}
        type="button"
        variant="outline"
        onClick={() => navigate("/request")}
        className="w-full h-11 border-amber-500/40 text-amber-400 hover:bg-amber-500/10 hover:text-amber-300 font-semibold"
      >
        <Car size={18} weight="fill" className="mr-2" />
        {t("auth.book_no_account")}
      </Button>
    </div>
  );
}
